import { render, staticRenderFns } from "./add-file.vue?vue&type=template&id=4dc41d44"
import script from "./add-file.vue?vue&type=script&lang=js"
export * from "./add-file.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports